import { apiClient } from '@/lib/api-client'

export type PublicStatus =
  | 'operational'
  | 'degraded'
  | 'partial_outage'
  | 'major_outage'
  | 'maintenance'

export interface StatusComponent {
  id: number
  name: string
  slug: string
  description: string | null
  status: PublicStatus
  status_message: string | null
  last_checked_at: string | null
}

export interface StatusIncidentUpdate {
  id: number
  state: 'investigating' | 'identified' | 'monitoring' | 'resolved'
  message: string
  posted_at: string
}

export interface StatusIncident {
  id: number
  title: string
  state: 'investigating' | 'identified' | 'monitoring' | 'resolved'
  impact: 'minor' | 'major' | 'critical'
  message: string
  started_at: string
  resolved_at: string | null
  updates: StatusIncidentUpdate[]
}

export interface StatusMaintenanceWindow {
  id: number
  title: string
  message: string
  starts_at: string
  ends_at: string
  status: PublicStatus
}

export interface StatusSnapshot {
  generated_at: string
  overall_status: PublicStatus
  components: StatusComponent[]
  incidents: StatusIncident[]
  maintenance: StatusMaintenanceWindow[]
}

export const statusPageService = {
  async getSnapshot(): Promise<StatusSnapshot> {
    const response = await apiClient.get<StatusSnapshot>('/api/v1/status')
    return response.data
  },
}
